module.exports = __webpack_public_path__ + "img/traditional_agent_graph.7305c395.svg";